export default class AngleMonkey extends Component {
  render() {
    return (
      <Surface gridColumn="screen" alignItems="center" marginY={40}>
        <Surface flexFlow="row" alignItems="center">
          <Surface width={500}>
            <Text size={500} marginTop={10} fontWeight={400} lineHeight={1.4}>
              <a href="https://www.sciencedirect.com/science/article/pii/S096098221731521X#app2">
                Tang et el
              </a>{" "}
              looked at how a biological neuron in the primary visual cortex of
              a macaque monkey responds to 9,500 shapes. One of the shapes that
              excites it most is a curved arc with outwardly protruding lines.
            </Text>

            <img
              src={require("./all-bio-row1.png")}
              width={500}
              style={{ marginTop: 20 }}
            />
            <img src={require("./all-bio-row2.png")} width={500} />
            <Text fontStyle="italic" marginTop={5} marginLeft={5}>
              Samples from the 9,500 tested shapes. Red corresponds to higher
              activation.
            </Text>
            {false &&
              "paper is https://www.sciencedirect.com/science/article/pii/S096098221731521X#app2"}
          </Surface>

          <Surface alignItems="center" marginLeft={50}>
            <Surface>
              <img
                style={{
                  margin: 0,
                  padding: 0,
                  border: "1px solid rgba(0, 0, 0, 0.2)",
                }}
                src={require("./bio.png")}
                width={265}
              />
            </Surface>
            <Text fontStyle="italic" marginTop={5} marginLeft={5}>
              Near-maximal stimuli for a biological neuron
            </Text>
          </Surface>
        </Surface>
      </Surface>
    )
  }
}
